<template>
    <!-- <div v-show="!false"> -->
    <div v-show="!isBusinessClientWithSingleCompany">
        <v-card class="default_card_admin">
            <v-container fluid grid-list-md>
                <v-row class="pb-2">
                    <h2>Périmètre</h2>
                </v-row>
                <v-row class="align-center">
                    <div class="flex-grow-1 flex-shrink-0" v-on:click="openEdition()">
                        <v-text-field-filled
                            :model-value="computedName"
                            placeholder="Aucun perimètre choisi"
                            readonly
                            density="compact"
                            class="mr-3 pointer_text_field"
                            append-inner-icon="$oss-eye"
                            data-cy="ScopeManager-perimetre"
                        />
                    </div>
                    <v-btn
                        size="small"
                        elevation="0"
                        rounded
                        color="primary"
                        @click="openDialog"
                        :disabled="readonly"
                    >
                        <v-icon size="large" left>$oss-article</v-icon> 
                        <span class="pl-2">Choisir</span>
                    </v-btn>
                </v-row>
            </v-container>
        </v-card>
        <oss-dialog 
            v-model="dialog" 
            :eager="true"
            @valid="valid"
            :validDisabled="!validName"
            :hideValid="currentStep === 'selectScope'"
            :validTitle="validTitle"
            width="60vw"
            @previous="previousStep"
            :previous-display="['createScope'].includes(currentStep)"
            @after-enter="scrollToIndex"
            @close="closeDialog"
        >
        <v-window v-model="currentStep">
            <v-window-item value="selectScope">
                <div class="pt-2" style="width: 100%">
                    <v-col class="d-flex justify-start align-center flex-grow-1 flex-shrink-0">
                        <v-text-field-filled
                            label="Rechercher"
                            v-model="searchScope"
                            outlined
                            density="compact"
                        />
                        <v-btn-add rounded="xl" class="ml-2" @click="setEditScope({id: null})">
                        </v-btn-add>
                    </v-col>
                    <v-virtual-scroll
                        ref="virtualScroll"
                        :benched="20"
                        :items="filteredScopeList"
                        height="500"
                        item-height="64"
                        class="mx-2"
                    >
                        <template v-slot:default="{ item }">
                            <v-list-item
                                :key="(item as any).id"
                                :class="
                                    !$vuetify.display.mobile
                                        ? 'mb-2 oss-list-item'
                                        : 'mb-2 px-2 oss-list-item'
                                "
                                border="sm"
                                variant="outlined"
                                rounded="xl"
                                density="comfortable"
                                style="height: 70px"
                                :disabled="isReadonly(item)"
                            >
                                <template #prepend>
                                    <v-checkbox-btn
                                        density="comfortable"
                                        :model-value="idSync === (item as any).id"
                                        @update:model-value="selectScopes(item)"
                                        color="primary"
                                        class="pr-3 pa-0"
                                    />
                                </template>
                                <v-list-item-title>
                                    {{ (item as any).name || "_" }}
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    <small class="mb-4 text-caption">
                                        {{ getCountName(item) }}
                                    </small>
                                </v-list-item-subtitle>
                                <v-list-item-subtitle>
                                    <template v-for="(value, key) in getTargets(item)" :key="(item as any).name + key">
                                        <v-chip
                                            label
                                            class="mr-2"
                                            v-if="value"
                                            size="x-small"
                                        >
                                            {{ value }}
                                        </v-chip>
                                    </template>
                                </v-list-item-subtitle>
                                <template #append>
                                    <v-btn-icon
                                        icon="$oss-edit"
                                        @click.stop="setEditScope(item)"
                                        size="small"
                                    />
                                </template>
                            </v-list-item>
                        </template>
                    </v-virtual-scroll>
                </div>
            </v-window-item>
            <v-window-item value="createScope">
                <Scope
                    ref="refScope"
                    v-model="scopeSync"
                    v-model:id="scopeId"
                    v-model:name="nameSync"
                    :initialCompany="initialCompany"
                    :accountingFirmId="accountingFirmId"
                    :returnScopedCompanies="returnScopedCompanies"
                    :hideCompany= "hideCompany"
                    :hideActivity= "hideActivity"
                    :hideTaxSystem= "hideTaxSystem"
                    @scopedCompanies="onScopedCompaniesChanged"
                    @validName="validName = $event"
                />
            </v-window-item>
        </v-window>
        </oss-dialog>
    </div>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";
import { Component, Vue, toNative, Model, Watch, Prop } from "vue-facing-decorator";
import { Ref } from "vue-facing-decorator";

import OssDataTable from "../ossComponents/ossDataTable2.vue";
import Scope from "./Scope.vue";

import COMPANY_SCOPE from "@/graphql/CompanyScope.gql";
import COMPANY_SCOPES_LIST from "@/graphql/CompanyScopesList.gql";
import CLIENT_COMPANY_COUNT from "@/graphql/company/ClientCompanyCount.gql";

@Component({
    components: {
        OssDataTable,
        Scope,
    },
    emits: ["scopedCompanies"],
})
export class ScopeManager extends Vue {
    @Model({ type: String, name: "companyScope" }) scopeSync!: any;
    @Model({ type: String, default: "", name: "id" }) idSync: string;
    @Model({ type: String, default: "", name: "name" }) nameSync: string;

    @Prop({ default: null }) initialCompany: string;
    @Prop({ default: false }) readonly: boolean;
    @Prop({ default: false }) hideCompany: boolean;
    @Prop({ default: false }) hideActivity: boolean;
    @Prop({ default: false }) hideTaxSystem: boolean;
    @Prop({ default: false }) returnScopedCompanies: boolean;

    @Ref() virtualScroll: any;
    @Ref() readonly refScope!: any;

    dialog: boolean = false;
    company: any = null;

    searchScope: string = "";

    currentStep = "createScope"

    loading = false;
    search = "";

    validName = false;

    scopeId_: string = "";

    get scopeId() {
        if (this.scopeSync?.id) {
            this.scopeId_ = this.scopeSync?.id;
        }
        return this.scopeId_;
    }

    set scopeId(value) {
        this.scopeId_ = value;
    }

    get computedName() {
        if(this.nameSync) {
            return this.nameSync
        }
        if(this.idSync) {
            return "Périmètre non nommé"
        }
        return ""
    }

    get forClient(): boolean {
        return !!this.$store.state.selected_company;
    }

    get accountingFirmId() {
        //
        // in production
        //
        if (this.forClient) {
            return this.$store.state.selected_company?.id;
        }
        // in gi
        //
        return this.$store.state.companyAccountingFirm.id;
    }

    get accountingCompanyId() {
        return this.$store.state.companyAccountingFirm.id;
    }

    get currentUser () {
        return this.$store.state.user
    }

    get isBusinessClient () {
        return this.currentUser.isBusinessClient
    }

    get isBusinessClientWithSingleCompany() {
        return this.isBusinessClient && this.clientCompanyCount === 1
    }

    get title() {
        switch(this.currentStep) {
            case "selectScope":
                return "Choisir un perimètre"
            case "createScope":
                if(this.scopeId) {
                    return "Éditer le perimètre"
                }
                return "Créer un perimètre"
        }
    }

    get validTitle() {
        if(!this.scopeId && this.currentStep === "createScope") {
            return "Créer"
        }
        return "Valider"
    }

    get filteredScopeList() {
        let scopesList = this.scopesList.sort((a, b) => {
            const aName = a.name || ""
            const bName = b.name || ""
            if (aName < bName) return -1;
            if (aName > bName) return 1;
            return 0;
        });
        if (this.searchScope) {
            scopesList = scopesList.filter((scope) => {
                if(!scope.name) return
                return (scope.name.toLowerCase().indexOf(this.searchScope.toLowerCase()) !== -1);
            });
        }
        return scopesList;
    }

    isReadonly(companyScope) {
        const accountingCompanyId = companyScope?.accountingCompany?.id
        const accountingCompanyOwnerId = companyScope?.accountingCompanyOwner?.id
        if (accountingCompanyId == undefined && accountingCompanyOwnerId !== this.accountingCompanyId) {
            return true;
        }
        return false
    }

    getTargets(scope) {
        const targets = {
            company: "",
            activity:"",
            taxSystem: "",
            default: ""
        }
        if (scope.accountingCompany) {
            if (scope.clients.length) {
                targets.company = "Pour " + scope.clients.length.toString() + " client(s)";
            } if (scope.taxSystems) {
                targets.taxSystem = "Pour les " + scope.taxSystems + " de mon cabinet";
            } if (scope.activities && scope.activities.length) {
                targets.activity =  "Pour " + scope.activities.length.toString() +
                    " activité(s) de mon cabinet";
            } 
            if(!targets.company && !targets.activity && !targets.taxSystem) {
                targets.default = "Pour tous les clients de mon cabinet";
            }
        } else if (scope.taxSystems) {
            targets.taxSystem = "Pour les " + scope.taxSystems + " de tous les cabinets";
        } else if (scope.activities && scope.activities.length) {
            targets.activity =  "Pour " + scope.activities.length.toString() +
                " activité(s) de tous les cabinets"
            ;
        } else {
            targets.default = "Pour tous les clients de tous les cabinets";
        }
        return targets;
    }

    showName() {
        this.nameSync = this.scopesList.find(scope => scope.id === this.idSync)?.name
    }

    getCountName(item) {
        if(item._count === 1) {
            return "Utilisé dans une règle"
        }
        return "Utilisé dans " + item._count + " règles"
    }

    openEdition() {
        if(!this.readonly) {
            this.dialog = true; 
            this.setEditScope({id:this.idSync})
        }
    }

    openDialog() {
        this.currentStep = "selectScope"
        this.dialog = true;
    }

    previousStep() {
        this.currentStep = "selectScope";
    }

    setEditScope(scope) {
        this.scopeId = scope.id
        this.currentStep = "createScope"
    }

    selectScopes(scope) {
        if(scope.id !== this.idSync) {
            this.idSync = scope.id
            this.scopeId = scope.id
            this.nameSync = scope.name
        } else {
            this.idSync = null
            this.nameSync = ""
        }
    }
    
    async valid() {
        if(this.currentStep === "createScope") {
            if(this.refScope) {
                await this.refScope.upsert();
                if (this.$apollo.queries) {
                    if (this.$apollo.queries.scopesList) {
                        await this.$apollo.queries.scopesList.refetch();
                        this.idSync = this.scopeId
                        this.showName()
                    }
                }
            }
        }
        this.dialog = false;
    }

    async createScopeForClient() {
        if(!this.idSync) {
            // debugger
            if(this.forClient && this.refScope) {
                const specificScope = this.scopesList.find(cs => 
                    cs.clientCount === 1 && cs.clients[0]?.id === this.accountingFirmId
                );
                if(specificScope) {
                    this.idSync = specificScope.id;
                    this.nameSync = specificScope.name;
                } else {
                    this.refScope.companyScope.clients.length = 0;
                    this.refScope.companyScope.clients.push(this.initialCompany);
                    this.refScope.companyScope.activities.length = 0;
                    this.refScope.companyScope.taxSystems.length = 0;
                    this.refScope.companyScope.name = `Périmètre pour ${this.$store.state.selected_company.name || "-"}`
                    await this.refScope.upsert();
                    this.idSync = this.scopeId
                }
            }
        }
    }

    @Watch("dialog")
    closeDialog() {
        if(this.dialog) {
            return
        }
        this.scopeId = this.idSync
        this.currentStep = "selectScope"
        this.refScope.step = "definition"
        this.showName()
    }

    // Ensure scoped companies are emitted when parent company passes scopeId on component mounted
    firstRendered = false
    @Watch("id") 
    firstEmitScopedCompanies() {
        if(this.idSync && !this.firstRendered) {
            this.firstRendered = true
            this.scopeId = this.idSync
        }
    }

    @Apollo({
        query: COMPANY_SCOPE,
        fetchPolicy: "network-only",
        variables() {
            return {
                id: this.idSync,
            };
        },
        skip() {
            return !this.idSync;
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.loading = loading;
            if (!loading && data) {
                if (data.companyScope.taxSystems) {
                    data.companyScope.taxSystems = data.companyScope.taxSystems.split(";");
                } else {
                    data.companyScope.taxSystems = [];
                }
                this.companyScopeArrays =  { 
                    clients: data.companyScope.clients,
                    taxSystems: data.companyScope.taxSystems,
                    activities: data.companyScope.activities,
                }
            }
        },
    })
    companyScopeArrays = {
        clients: [],
        activities: [],
        taxSystems: []
    }

    @Apollo({
        query: COMPANY_SCOPES_LIST,
        variables() {
            return {
                accountingCompanyId: this.accountingCompanyId,
                duplicates: false,
                selectedCompanyId: this.forClient ? this.accountingFirmId : undefined,
                singleCompany: this.isBusinessClientWithSingleCompany,
            };
        },
        skip(){
            return !this.accountingCompanyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data) {
                    // debugger
                    if(!this.idSync && (this.isBusinessClientWithSingleCompany)) {
                        this.idSync = data.companyScopesList.scopes.id
                    }
                    if(this.forClient) {
                        if(!this.idSync) {
                            const specificScope = data.companyScopesList.scopes.find(cs => 
                                cs.clientCount === 1 && cs.clients[0]?.id === this.accountingFirmId
                            );
                            if(specificScope) {
                                this.idSync = specificScope.id;
                                this.nameSync = specificScope.name;
                            }
                        }
                    }
                    if (data.companyScopesList?.scopes?.length) {
                        this.scopesList = data.companyScopesList.scopes;
                    } else {
                        this.scopesList = [];
                    }
                }
            }
        }
    })
    scopesList: any = [];

    @Apollo({
        query: CLIENT_COMPANY_COUNT,
        variables() {
            return {
                companyId: this.accountingCompanyId
            };
        },
        skip(){
            return !this.isBusinessClient || !this.accountingCompanyId
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                // debugger
                if (data.clientCompanyCount) {
                    this.clientCompanyCount = data.clientCompanyCount;
                }
            }
        }
    })
    clientCompanyCount: number = 0;

    scrollToIndex() {
        if(this.currentStep === "selectScope") {
            const index = this.filteredScopeList.findIndex(
                (item) => item.id === this.idSync
            );
            if (index !== -1) {
                console.log("scrolling to: ",index)
                if (this.virtualScroll && typeof this.virtualScroll.scrollToIndex === "function") {
                    this.virtualScroll.scrollToIndex(index);
                }
            }
        }
        
    }

    onScopedCompaniesChanged(companies) {
        this.$emit("scopedCompanies",companies)
    }
}

export default toNative(ScopeManager);
</script>

<style scoped>
:deep(.pointer_text_field input) {
    cursor: pointer;
}
:deep(.pointer_text_field .v-field__append-inner) {
    cursor: pointer;
}
</style>